import { Checkbox, CheckboxGroup } from "@vds/checkboxes";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemSubtitle,
  ListGroupItemTitle,
} from "@vds/lists";
import { Loader } from "@vds/loaders";
import { RadioBoxGroup } from "@vds/radio-boxes";
import { DropdownSelect } from "@vds/selects";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotificationGroupsEndPoint } from "../../../configuration";
import axiosInstance from "../../../global/axiosInterceptor";
import { Toggle } from "@vds/toggles";
import {
  ActionsInsideFrame,
  ConditionContainer,
  GreyText,
  NotificationText,
} from "../../../global/components/Modals/RoiModals/stylesRoiModal";
import UsersEllipse from "../../../global/components/Modals/RoiModals/UsersEllipse";
import { updateRuleValue, showNotificationBanner } from "../../../store/actions";
import {
  ActionsFrame,
  AlertNameFrameAndTimeFrame,
  AlertNameInputFrame,
  AlertPreferences,
  SetTriggerContainer,
  UserGroupContainer,
  UserGroupsFrame,
  UserHeadingText,
} from "../../Rules/Rulesstyle";
import "../bulkrule.css";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import { CREATERULE_TEST_IDS } from "./createRuleConstants";
import CustomTimeFrame from "./CustomTimeFrame";
import Trigger from "./Trigger";
import { NOTIFICATION_MESSAGES } from "../../../layouts/NotificationConfig";
import { CV_APP_TYPE_EVENT } from "../../../global/constants/cvappConstants";

const SetTrigger = (props) => {
  const isReadOnly = props?.isReadOnly || false;
  const isEventapp = props?.selAppType === CV_APP_TYPE_EVENT ? true : false;
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const {
    appSelected,
    triggerActions,
    triggerActions: { groups, sms, email, severity, timeFrame },
    notificationGroups,
    captureVideoEvidence,
  } = useSelector((state) => state.ruleReducer);
  const [notificationUsers, setNotificationUsers] = useState();
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);
  const [all, setAll] = useState(false);
  const [disableNotification, setDisableNotification] = useState(true);
  const [smsState, setSmsState] = useState(false);
  const [emailState, setEmailState] = useState(false);
  const [isVideoEvidenceCapture, setIsVideoEvidenceCapture] = useState(captureVideoEvidence ?? true);

  const dispatch = useDispatch();
  const { width } = useWindowSize();

  const fetchNotificationGroups = async () => {
    try {
      const response = await axiosInstance.post(
        fetchNotificationGroupsEndPoint(),
        {
          accountname: activeSession.accountId,
        }
      );
      const data = response.data;
      const groupNames =
        (data?.length &&
          data?.map((item) => {
            const allUsers = item?.users?.map((user) => ({
              name: `${user?.firstname} ${user?.lastname}`,
              email: user?.email,
              number: user?.mdn,
            }));
            const displayedUsers = allUsers
              ?.slice(0, 6)
              ?.map((user) => user?.name);
            return {
              label: item?.name,
              value: item?.name,
              displayedUsers: displayedUsers?.join(", "),
              allUsers,
              hasMoreUsers: allUsers?.length > 6,
            };
          })) ||
        [];
      dispatch(
        updateRuleValue({ propName: "notificationGroups", value: groupNames })
      );
      setNotificationUsers(groupNames);
      setLoading(false);
    } catch (error) {
      const notificationInfo = {
        type: NOTIFICATION_MESSAGES.FAILED_TO_FETCH,
        priority: "critical",
        showNotification: true,
        data: {
          subTitle: NOTIFICATION_MESSAGES.FETCH_NOTIFICATION_GROUPS_FAIL_SUBTITLE
        }
      };
      dispatch(showNotificationBanner(notificationInfo));
      setFetchError(true);
      setLoading(false);
      console.error("Failed to fetch notification groups", error);
    }
  };

  useEffect(() => {
    if (props?.ruleList) {
      setSmsState(
        props?.ruleList?.smsNotification || props?.ruleList?.sms || false
      );
      setEmailState(
        props?.ruleList?.emailNotification || props?.ruleList?.email || false
      );
      dispatch(
        updateRuleValue([
          {
            propName: "triggerActions",
            value: {
              ...triggerActions,
              sms: props?.ruleList?.smsNotification || false,
            },
          },
          {
            propName: "triggerActions",
            value: {
              ...triggerActions,
              email: props?.ruleList?.emailNotification || false,
            },
          },
        ])
      );
    }
    setDisableNotification(groups?.length === 0);
  }, [props?.ruleList]);

  useEffect(() => {
    if (notificationGroups && notificationGroups?.length === 0) {
      fetchNotificationGroups();
    } else {
      setLoading(false);
    }
  }, [notificationGroups.length]);

  const handleToggle = () => {
    setAll(!all);
  };

  const handleTimeFrameChange = (event) => {
    // console.log("TIMEFRAME DATA >>", event.target.value);
    dispatch(
      updateRuleValue({
        propName: "triggerActions",
        value: { ...triggerActions, timeFrame: event.target.value },
      })
    );
  };

  const handleGroupChange = (option) => {
    const isAlreadySelected =
      groups && groups.some((group) => group?.label === option?.label);
    let updatedSelectedUsers;

    if (isAlreadySelected) {
      updatedSelectedUsers =
        groups && groups.filter((group) => group.label !== option?.label);
    } else {
      updatedSelectedUsers = [...groups, option];
    }
    dispatch(
      updateRuleValue({
        propName: "triggerActions",
        value: { ...triggerActions, groups: updatedSelectedUsers },
      })
    );
  };

  useEffect(() => {
    const group = groups && groups?.map((group) => group.label).join(",");
    if (group?.length > 0) {
      setDisableNotification(false);
    } else {
      setDisableNotification(true);
    }
  }, [handleGroupChange]);

  const updateValues = (type, data) => {
    const newObj = {};
    newObj[type] = data;
    dispatch(updateRuleValue({ propName: "triggerActions", value: newObj }));
    if (type === "sms") {
      setSmsState(data);
      dispatch(
        updateRuleValue({ propName: "triggerActions", value: { sms: data } })
      );
    } else if (type === "email") {
      setEmailState(data);
      dispatch(
        updateRuleValue({ propName: "triggerActions", value: { email: data } })
      );
    }
  };

  return (
    <>
      <SetTriggerContainer isEditing={props?.isEditing}>
        {!props?.isEditing && (
          <div className="appAndSiteDropdown-Wrapper">
          <div className="bulk-rule-content-header-text bottom-margin-20">
            Set the trigger for this alert.
          </div>
          {isEventapp && <div className="bulk-rule-content-header-text bottom-margin-20">
            {!isReadOnly && <Toggle
                              on={isVideoEvidenceCapture}
                              surface="light"
                              showText={true}
                              textWeight="regular"
                              textSize="small"
                              textPosition="right"
                              statusText={(e) => (e ? "Capture Video Evidence" : "Capture Video Evidence")}
                              data-testid="ruleDetails_CaptureVideoEvidenceToggle"
                              onChange={(e) => {
                                 dispatch(
                                   updateRuleValue({
                                     propName: "captureVideoEvidence",
                                     value: !isVideoEvidenceCapture
                                   })
                                 );
                                setIsVideoEvidenceCapture(!isVideoEvidenceCapture);
                              }}
                            />}
            {isReadOnly &&
                            <Toggle
                              on={isVideoEvidenceCapture}
                              surface="light"
                              showText={true}
                              textWeight="regular"
                              textSize="small"
                              textPosition="right"
                              statusText={(e) => (e ? "Capture Video Evidence" : "Capture Video Evidence")}
                              data-testid="ruleDetails_CaptureVideoEvidenceToggle"
                            />}
          </div>}
          </div>
        )}
        

        <Trigger
          EventTrigger={
            appSelected?.name ? appSelected?.name : props?.ruleList?.cvAppName
          }
          action={false}
          isReadOnly={isReadOnly}
          cvappid={
            appSelected?.id ? appSelected?.id : props?.ruleList?.serviceid
          }
          result={props?.result}
          isEditing={props?.isEditing}
        />

        <AlertNameFrameAndTimeFrame Action={true}>
          <GreyText>Time frame</GreyText>
          <ConditionContainer>
            <AlertNameInputFrame timeFrame={true}>
              <RadioBoxGroup
                orientation="horizontal"
                data={[
                  {
                    id: "RB1",
                    value: "RB1",
                    text: "Always active (default)",
                    subtext: "Always receive alerts",
                    type: "radioBox",
                    name: "RadioBoxGroup1",
                    // onChange: () => handleTimeFrameChange("Always active (default) Always receive alerts"),
                    // selected: timeFrame === "Always active (default) Always receive alerts",
                    selected: timeFrame == "RB1",
                    disabled: isReadOnly,
                  },
                  {
                    id: "RB2",
                    value: "RB2",
                    text: "Custom time frame",
                    subtext: "Choose hours & days of the week",
                    type: "radioBox",
                    name: "RadioBoxGroup2",
                    // onChange: () => handleTimeFrameChange("Custom time frame Choose hours & days of the week "),
                    // selected: timeFrame === "Custom time frame Choose hours & days of the week ",
                    selected: timeFrame == "RB2",
                    disabled: isReadOnly,
                  },
                ]}
                value={timeFrame}
                onChange={handleTimeFrameChange}
                data-testid={CREATERULE_TEST_IDS.TIMEFRAME_RADIO_GROUP}
              />
              {timeFrame === "RB2" && (
                <CustomTimeFrame isReadOnly={isReadOnly} />
              )}
            </AlertNameInputFrame>
          </ConditionContainer>
        </AlertNameFrameAndTimeFrame>

        <ActionsFrame>
          <ActionsInsideFrame>
            <ConditionContainer className="top-margin-10">
              <DropdownSelect
                label="Severity"
                errorText="Select a state"
                error={false}
                disabled={false}
                readOnly={isReadOnly}
                inlineLabel={false}
                width={width < 480 ? "100%" : "348px"}
                onChange={(e) => updateValues("severity", e.target.value)}
                data-testid={CREATERULE_TEST_IDS.SEVERITY_DROPDOWN}
              >
                <option value="">Select</option>
                <option selected={"Critical" === severity}>Critical</option>
                <option selected={"Minor" === severity}>Minor</option>
              </DropdownSelect>
            </ConditionContainer>
            {(isReadOnly == true && groups && groups?.length > 0) ||
            isReadOnly == false ? (
              <>
                <NotificationText>Notifications</NotificationText>
                <UserHeadingText>
                  Select all user groups to notify.
                </UserHeadingText>
              </>
            ) : (
              ""
            )}
            <ConditionContainer>
              <UserGroupsFrame style={{ display: "flex" }}>
                <UserGroupContainer>
                  {loading ? (
                      <div className="camera-snapshot-loader-wrapper">
                        <Loader active={true} fullscreen={false} surface="light" />
                      </div>
                  ) : !loading && fetchError ? (
                    <div className="error-message">
                      {NOTIFICATION_MESSAGES.FETCH_NOTIFICATION_GROUPS_FAIL_SUBTITLE}
                    </div>
                  ) : !loading && (notificationUsers?.length === 0) ? (
                    <div className="no-data-message">
                      {NOTIFICATION_MESSAGES.NO_NOTIFICATION_GROUPS_AVAILABLE}
                    </div>
                  ) : null}
                  <ListGroup
                    topLine={false}
                    bottomLine={false}
                    surface="light"
                    viewport="mobile"
                  >
                    {isReadOnly
                      ? groups?.map((option, index) => (
                          <ListGroupItem
                            key={index}
                            actionElement={isReadOnly ? isReadOnly : "none"}
                            topLine={false}
                            bottomLine={false}
                            disabled={isReadOnly}
                            selected={true}
                          >
                            <ListGroupItemTitle bold={false}>
                              <Checkbox
                                selected={isReadOnly ? isReadOnly : true}
                                disabled={isReadOnly}
                                label={option?.label}
                              />
                            </ListGroupItemTitle>
                            {option?.label && (
                              <ListGroupItemSubtitle>
                                <UsersEllipse
                                  group={option}
                                  handleToggle={handleToggle}
                                  all={all}
                                />
                              </ListGroupItemSubtitle>
                            )}
                          </ListGroupItem>
                        ))
                      : (notificationUsers || notificationGroups)?.map(
                          (option, index) => (
                            <ListGroupItem
                              key={index}
                              actionElement={isReadOnly ? isReadOnly : "none"}
                              topLine={false}
                              bottomLine={false}
                              disabled={isReadOnly}
                              selected={true}
                            >
                              <ListGroupItemTitle bold={false}>
                                {props?.isEditing ? (
                                  <label>
                                    <Checkbox
                                      disabled={isReadOnly}
                                      selected={
                                        groups &&
                                        groups?.some(
                                          (group) =>
                                            group?.label === option?.label
                                        )
                                          ? true
                                          : false
                                      }
                                      onChange={() => handleGroupChange(option)}
                                      data-testid={CREATERULE_TEST_IDS.NOTIFICATION_GROUP_CHECKBOX}
                                    >
                                      {option?.label}
                                    </Checkbox>
                                  </label>
                                ) : !props?.isEditing ? (
                                  <Checkbox
                                    disabled={isReadOnly}
                                    selected={
                                      groups &&
                                      groups?.some(
                                        (group) =>
                                          group?.label === option?.label
                                      )
                                    }
                                    onChange={() => handleGroupChange(option)}
                                    data-testid={CREATERULE_TEST_IDS.NOTIFICATION_GROUP_CHECKBOX_EDIT}
                                  >
                                    {option?.label}
                                  </Checkbox>
                                ) : (
                                  option?.label
                                )}
                              </ListGroupItemTitle>
                              {option?.label && (
                                <ListGroupItemSubtitle>
                                  <UsersEllipse
                                    group={option}
                                    handleToggle={handleToggle}
                                    all={all}
                                  />
                                </ListGroupItemSubtitle>
                              )}
                            </ListGroupItem>
                          )
                        )}
                  </ListGroup>
                </UserGroupContainer>

                <AlertPreferences>
                  <div>
                    {(isReadOnly == true && groups && groups?.length > 0) ||
                    isReadOnly == false ? (
                      <>
                        <UserHeadingText>
                          Notification Preferences
                        </UserHeadingText>
                        <div>
                          {props?.ruleList ? (
                            <CheckboxGroup
                              Surface="light"
                              data={[
                                {
                                  children: "SMS",
                                  value: "Apple (25)",
                                  width: "auto",
                                  selected: disableNotification
                                    ? false
                                    : smsState,
                                  onChange: () =>
                                    updateValues("sms", !smsState),
                                  disabled: disableNotification,
                                  "data-testid": CREATERULE_TEST_IDS.SMS_NOTIFICATION_CHECKBOX,
                                },
                                {
                                  children: "Email",
                                  value: "Google (3)",
                                  width: "auto",
                                  selected: disableNotification
                                    ? false
                                    : emailState,
                                  onChange: () =>
                                    updateValues("email", !emailState),
                                  disabled: disableNotification,
                                  "data-testid": CREATERULE_TEST_IDS.EMAIL_NOTIFICATION_CHECKBOX,
                                },
                              ]}
                              className="d-flex flex-lg-row align-items-baseline gap-4 m-0 p-0"
                            />
                          ) : (
                            <CheckboxGroup
                              Surface="light"
                              data={[
                                {
                                  children: "SMS",
                                  value: "Apple (25)",
                                  width: "auto",
                                  selected: props?.isReadOnly
                                    ? sms
                                    : !disableNotification && sms,
                                  onChange: () => updateValues("sms", !sms),
                                  "data-testid": CREATERULE_TEST_IDS.SMS_NOTIFICATION_CHECKBOX_EDIT,
                                  disabled: props?.isReadOnly
                                    ? props?.isReadOnly
                                    : disableNotification,
                                },
                                {
                                  children: "Email",
                                  value: "Google (3)",
                                  width: "auto",
                                  selected: props?.isReadOnly
                                    ? email
                                    : !disableNotification && email,
                                  onChange: () => updateValues("email", !email),
                                  "data-testid": CREATERULE_TEST_IDS.EMAIL_NOTIFICATION_CHECKBOX_EDIT,
                                  disabled: props?.isReadOnly
                                    ? props?.isReadOnly
                                    : disableNotification,
                                },
                              ]}
                              className="d-flex flex-lg-row align-items-baseline gap-4 m-0 p-0"
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </AlertPreferences>
              </UserGroupsFrame>
            </ConditionContainer>
          </ActionsInsideFrame>
        </ActionsFrame>
      </SetTriggerContainer>
    </>
  );
};

export default SetTrigger;
